import React from 'react'

import useForm from 'react-hook-form'
import { RHFInput } from 'react-hook-form-input'

import { TextField, Box, Button, makeStyles } from '@material-ui/core'

import styles from './styles'
import schemas from './../../../../schemas'

const useStyles = makeStyles(styles)

const SettingsWebhookForm = ({ settings, handleClose, onSubmit }) => {
  const classes = useStyles()

  const { register, setValue, errors, handleSubmit } = useForm({
    validationSchema: schemas.webhook,
    defaultValues: {
      urlNotificationDefaultInvoices:
        settings.urlNotificationDefaultInvoices.value,
      urlNotificationDefaultContract:
        settings.urlNotificationDefaultContract.value,
    },
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={classes.root}>
      <RHFInput
        as={
          <TextField
            margin="dense"
            label="Notificação de alterações e criação de faturas"
            error={!!errors.urlNotificationDefaultInvoices}
            helperText={
              errors.urlNotificationDefaultInvoices &&
              errors.urlNotificationDefaultInvoices.message
            }
            fullWidth
          />
        }
        register={register}
        setValue={setValue}
        name="urlNotificationDefaultInvoices"
      />
      <RHFInput
        as={
          <TextField
            margin="dense"
            label="Notificação de alterações e criação de assinaturas"
            error={!!errors.urlNotificationDefaultContract}
            helperText={
              errors.urlNotificationDefaultContract &&
              errors.urlNotificationDefaultContract.message
            }
            fullWidth
          />
        }
        register={register}
        setValue={setValue}
        name="urlNotificationDefaultContract"
      />

      <Box pt={2}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={classes.btnSave}
        >
          Salvar
        </Button>
        <Button
          type="button"
          variant="outlined"
          color="primary"
          onClick={handleClose}
        >
          Cancelar
        </Button>
      </Box>
    </form>
  )
}

export default SettingsWebhookForm
